import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { GetNegocioSignature } from "../../models/signature/GetNegocioSignature";
import { DetalheClienteCompletoSignature } from "../../models/signature/detalheClienteCompletoSignature";
import { GetNegocioCompartilhadoComigoSignature } from "../../models/signature/GetNegocioCompartilhadoComigoSignature";
import { GetNegocioAgendamentoDiaSignature } from "../../models/signature/GetNegocioAgendamentoDiaSignature";
import { FiltrosNegocioSignature } from "../../models/signature/FiltrosNegocioSignature";
import { BloquearDesbloquearNegocioSignature } from "../../models/signature/BloquearDesbloquearNegocioSignature";
import { GetNegocioCompartilheiSignature } from "../../models/signature/GetNegocioCompartilheiSignature";
import { ExcluirClienteSignature } from "../../models/signature/ExcluirClienteSignature";
import { environment } from "../../../../../../environments/environment";
import { RequestTokenService } from "../../../../../../services/request-token.service";
import { ExcluirNegocioSignature } from "../../models/signature/ExcluirNegocioSignature";
import { MarcarDesmarcarNegocioAcompanhamentoProcessoSignature } from "../../models/signature/MarcarDesmarcarNegocioAcompanhamentoProcessoSignature";
import { GetNegocioDasboardSignature } from "../../models/signature/GetNegocioDasboardSignature";

const API_URL = `${environment.apiUrl}v1/Negocio`;
const API_EXECUTIVO_URL = `${environment.apiExecutivoUrl}Negocio`;

@Injectable({
  providedIn: 'root'
})

export class NegocioService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }

  // @Retryable({ maxRetries: 2, timeoutEachMs: 10000, logEvents: true })
  public GetNegocio(signature: GetNegocioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true, // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/GetNegocio`, signature, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public GetNegocioDashboard(signature: GetNegocioDasboardSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true, // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_EXECUTIVO_URL}/GetNegocioDashBoard`, signature, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public GetNegocioCliente(dealId: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetNegocioCliente/${dealId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetNegocioClienteCompleto(signature: DetalheClienteCompletoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/GetNegocioClienteCompleto`, signature , options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetNegocioCompartilhadoComigo(signature: GetNegocioCompartilhadoComigoSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/GetNegocioCompartilhadoComigo`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetNegocioAgendamentoDia(signature: GetNegocioAgendamentoDiaSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/GetNegocioAgendamentoDia`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetNegocioComFiltro(signature: FiltrosNegocioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/GetNegocioComFiltro/`, signature,options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public BloquearDesbloquearNegocio(signature: BloquearDesbloquearNegocioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/BloquearDesbloquearNegocio/`, signature,options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetPrimeiroNegocioDoClient(clientId: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetPrimeiroNegocioDoClient/${clientId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetNegocioCompartilhei(signature: GetNegocioCompartilheiSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/GetNegocioCompartilhei`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public ExcluirCliente(signature: ExcluirClienteSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/ExcluirCliente`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public ExcluirNegocio(signature: ExcluirNegocioSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/ExcluirNegocio`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public CarregarNegociosCliente(clientId: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/CarregarNegociosCliente/${clientId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }


  public GetRendimentos(signature: {dataInicio?: string, dataFim?: string}): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/GetRendimentos`, signature, options)
  }

  public CarregarListaNegocio(clientId: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/CarregarListaNegocio/${clientId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public MarcarNegocioAcompanhamentoProcesso(signature: MarcarDesmarcarNegocioAcompanhamentoProcessoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/MarcarDesmarcarNegocioAcompanhamentoProcesso`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public CarregaTotalClientesPorUsuario(tipoTela: number): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/CarregaTotalClientesPorUsuario/${tipoTela}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetPainelVendasTodos(signature: any = {}): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };
    return this.http.post<any>(`${API_URL}/GetPainelVendasTodos`, signature, options)
      .pipe(catchError(this.handleError));
  }

  public GetPainelVendasAgendaDia(signature: any): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };
    return this.http.post<any>(`${API_URL}/GetPainelVendasAgendaDia`, signature, options)
      .pipe(catchError(this.handleError));
  }

  public GetPainelVendasNaoTrabalhado(signature: any = {}): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };
    return this.http.post<any>(`${API_URL}/GetPainelVendasNaoTrabalhado`, signature, options)
      .pipe(catchError(this.handleError));
  }

  public GetPainelVendasDisponiveis(signature: any = {}): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };
    return this.http.post<any>(`${API_URL}/GetPainelVendasDisponiveis`, signature, options)
      .pipe(catchError(this.handleError));
  }

  public GetPainelVendasCompartilhei(signature: any = {}): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };
    return this.http.post<any>(`${API_URL}/GetPainelVendasCompartilhei`, signature, options)
      .pipe(catchError(this.handleError));
  }

  public GetPainelVendasCompartilharam(signature: any = {}): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };
    return this.http.post<any>(`${API_URL}/GetPainelVendasCompartilharam`, signature, options)
      .pipe(catchError(this.handleError));
  }

  public GetPainelVendasFechado(signature: any = {}): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true,
    };
    return this.http.post<any>(`${API_URL}/GetPainelVendasFechado`, signature, options)
      .pipe(catchError(this.handleError));
  }

  public GetNegocioDashBoardRedistribuicao(signature: GetNegocioDasboardSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true, // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/GetNegocioDashBoardRedistribuicao`, signature, options)
      .pipe(
        catchError(this.handleError)
      );
  }
}
